import {Component} from '@angular/core';
import {AppConfigService} from '../../../app/app-config.service';

interface Capability {
  icon: string;
  label: string;
  link: string;
}

interface Priority {
  icon: string;
  title: string;
  description: string;
  tone: 'green' | 'teal' | 'blue';
}

@Component({
  selector: 'edc-demo-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent {

  constructor(private readonly appConfig: AppConfigService) {}

  // External resources.
  // TODO: point documentation at its dedicated URL once available.
  readonly aboutUrl = 'https://ceads.eu';
  readonly websiteUrl = 'https://ceads.eu';
  readonly documentationUrl = 'https://ceads.eu/how-ceads-works';
  readonly onboardingUrl = 'https://data-space-portal-ceads-data-space.apps.bst2.paas.psnc.pl/';

  readonly capabilities: Capability[] = [
    {icon: 'search', label: 'Browse agricultural datasets and services', link: '/browse-catalog'},
    {icon: 'handshake', label: 'Negotiate access under provider-defined policies', link: '/browse-catalog'},
    {icon: 'download', label: 'Transfer data securely between participants', link: '/transfer-history'},
    {icon: 'upload', label: 'Publish and manage your own assets', link: '/my-assets'},
    {icon: 'assignment', label: 'Monitor contracts and transfer history', link: '/contracts'},
    {icon: 'policy', label: 'Apply and manage policies for your assets', link: '/policies'},
  ];

  readonly priorities: Priority[] = [
    {icon: 'eco', title: 'Sustainability', description: 'Promoting sustainable farming and efficient resource use.', tone: 'green'},
    {icon: 'auto_graph', title: 'Innovation', description: 'Enabling data-driven innovation and new business opportunities.', tone: 'green'},
    {icon: 'verified_user', title: 'Data Sovereignty', description: 'Keeping control of data with clear policies and trusted exchange.', tone: 'teal'},
    {icon: 'groups', title: 'Collaboration', description: 'Bringing together stakeholders across the agri-food value chain.', tone: 'blue'},
    {icon: 'public', title: 'Interoperability', description: 'Ensuring data can be easily discovered, combined and reused.', tone: 'blue'},
  ];
}
